<nav ngClass.lt-sm="hidden">
  <button *ngFor="let tab of tabs; trackBy: trackByBundleId"
          (click)="click(tab.offerBundle)"
          [class.active]="tab.offerBundle.offerBundleId === currentOfferBundle.offerBundleId">
    <span class="tab-limit">{{tab.offerBundle.amount | currency:'USD':'symbol':'1.0-0'}}</span>
    <span class="tab-term">{{tab.term}}</span>
    <span *ngIf="tab.paymentFrequency"
          class="tab-frequency">{{tab.paymentFrequency}}</span>
  </button>
</nav>
<mat-form-field appearance="outline"
                ngClass.gt-xs="hidden">
  <mat-label>Repayment term</mat-label>
  <mat-select matInput
              autocomplete="off"
              [(value)]="currentOfferBundle.offerBundleId">
    <mat-option [value]="tab.offerBundle.offerBundleId"
                *ngFor="let tab of tabs; trackBy: trackByBundleId"
                (click)="click(tab.offerBundle)">
      {{tab.offerBundle.amount | currency:'USD':'symbol':'1.0-0'}} · {{tab.term}}{{tab.paymentFrequency ? ' · ' + tab.paymentFrequency : ''}}
    </mat-option>
  </mat-select>
</mat-form-field>
